export default "__VITE_ASSET__BRqy$luL__"